/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';
import utils from '../../../../common/utils';
import { getPromptV2Client, handlePromptServiceError } from './promptServiceHelpers';

export default class CreatePromptService extends BaseService {
  constructor() {
    super(constants.CREATE_PROMPT, 'createPromptStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { name, description, comments, promptStart, promptEnd, isAgentic = true } = payload;
    const requestBody = {
      name,
      description: description ?? '',
      comments: comments ?? '',
      promptStart: promptStart ?? [{ role: 'system', content: '' }],
      promptEnd: promptEnd ?? [{ role: 'user', content: '' }],
      isAgentic
    };
    const { client, headers: reqHeaders } = await getPromptV2Client(this, headers);
    return client.post('/prompts', requestBody, { headers: reqHeaders });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('studioPromptModel').handleCreateResponse(response.data);
  }

  handleError(error) {
    handlePromptServiceError(error, PROMPT_MANAGEMENT_LANG_KEYS.ERROR_CREATE, constants.CREATE_PROMPT_ERROR);
  }
}
